'use strict';
/**
 * @name masterDataPaymentTermsCtrl
 * @desc Controller for master data payment terms controller
 */
function masterDataManagePaymentTermsCtrl(
  $scope, $stateParams, toastr, dataList, paymentTermsMasterDataList, $uibModal, globalFunc, $location,
  pathConstants) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.paymentTermService = paymentTermsMasterDataList;

  $scope.addPaymentTerm = addPaymentTerm;
  $scope.editPaymentTerm = editPaymentTerm;
  $scope.search = search;
  $scope.showColumn = showColumn;
  $scope.params = {};
  $scope.duplicationCheck = duplicationCheck;
  $scope.importPaymentTerm = importPaymentTerm;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importLink = pathConstants.apiUrls.paymentTerms.import;

  $scope.columns =
    [
      {id: 'code', label: 'Code'},
      {id: 'descr', label: 'Description'},
      {id: 'updated_at', label: 'Updated At'},
      {id: 'updater.display_name', label: 'Updated By'},
      {id: 'created_at', label: 'Created At'},
      {id: 'creator.display_name', label: 'Created By'},
      {id: 'is_active', label: 'Status'}
    ];

  $scope.storageKey = 'master-data-payment-terms-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function search(query) {
    $location.search({query: query});
  }

  function importPaymentTerm() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Payment term';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function addPaymentTerm() {
      paymentTermsMasterDataList.post(
        {
        },
        {
          code: $scope.paymentTerms.code,
          descr: $scope.paymentTerms.descr,
          is_active: 1
        }
        ,
        function (resource) {
          toastr.success('Payment term has been added');
          if(!!resource.content && !!resource.content.data) {
            var addedPaymentTerm = resource.content.data;
            $scope.dataList.unshift({
              _id: addedPaymentTerm._id,
              code: addedPaymentTerm.code,
              descr: addedPaymentTerm.descr,
              created_at: addedPaymentTerm.created_at,
              updated_at: addedPaymentTerm.updated_at,
              updater: [$scope.user],
              creator: [$scope.user],
              is_active: 1
            });
          }
        },
        function (err) {
          globalFunc.objectErrorMessage(err);
        }
      )
  }

  function editPaymentTerm(paymentTerm){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/paymentTerms/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'editPaymentTermCtrl',
      scope: $scope,
      size: 'lg',
      resolve:{
        modalPaymentTerm: function($q,singlePaymentTerm){
          var deferred = $q.defer();
          singlePaymentTerm.get(
            {
              id: paymentTerm._id
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  function initialize(){
    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  initialize();

}

masterDataManagePaymentTermsCtrl.$inject = [
  '$scope', '$stateParams', 'toastr', 'dataList', 'paymentTermsMasterDataList', '$uibModal',
  'globalFunc', '$location', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('masterDataManagePaymentTermsCtrl', masterDataManagePaymentTermsCtrl);
